// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"overlayWrapper-Vp2Yr","dataAlert":"dataAlert-bTfTq","fixedWrapper":"fixedWrapper-bk0OL"};